<template>
  <div class="notification-point-item-parts">
    <div class="notification-point-item-parts__header">
      <div class="notification-point-item-parts__icon">
        <notification-point-icon />
      </div>
      <p class="notification-point-item-parts__date">{{ itemData.date }}</p>
    </div>
    <div class="notification-point-item-parts__body">
      <p class="notification-point-item-parts__title">{{ itemData.title }}</p>
    </div>
    <div class="notification-point-item-parts__footer">
      <p class="notification-point-item-parts__expiration-date">
        {{ $tc('NotificationPage.expirationDate') }} {{ itemData.expirationDate }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import NotificationPointIcon from '@/components/NotificationPane/NotificationPane/parts/icons/NotificationPointIcon.vue'

export interface PointData {
  id: string
  date: string
  title: string
  expirationDate: string
}

export default defineComponent({
  name: 'NotificationPointItemParts',
  components: { NotificationPointIcon },
  props: {
    itemData: {
      type: Object as PropType<PointData>,
      required: true,
    },
  },
})
</script>

<style scoped lang="scss">
.notification-point-item-parts {
  padding: 12px 11px 12px 16px;

  &__header {
    display: flex;
    gap: 8px;
    align-items: center;
    height: 36px;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    color: $green-light;
    background-color: $white;
    border-radius: 50%;
  }

  &__date {
    font-size: 13px;
    font-weight: 500;
    color: $black70;
    letter-spacing: 0.04em;
  }

  &__body {
    margin-top: 10px;
  }

  &__title {
    font-size: 14px;
    font-weight: 700;
    color: $black;
    letter-spacing: 0.02em;
  }

  &__footer {
    margin-top: 6px;
  }

  &__expiration-date {
    font-family: $fontSignup;
    font-size: 12px;
    font-weight: 500;
    color: $gray75;
    letter-spacing: 0.02em;
  }
}
</style>
